module.exports = __webpack_public_path__ + "static/media/ic_empowered_yellow.ff8f2610.svg";